import React from 'react'

// import Container from '../../layouts/Container/Container'
import LoginForm from '../organisms/LoginForm'
// import Banner from '../organisms/Banner'
// import BlackTitle from '../atoms/BlackTitle'
import HeaderLanding from '../../layouts/Header/HeaderLanding'

function Login({
  autologin,
  hash
}) {

  return (
    <>
      <HeaderLanding />
      <div className='mc-page login slow_ani'>
        {/* <Container> */}
        <LoginForm
          title="Título corto"
          type="credentials"
          fields={[
            { field: "code", label: "Introduce el código recibido en tu correo electrónico", placeholder: "Escribe tu código de 6 dígitos", maxlength: 6, separated: false, tooltip: "¿No recibiste el código? Revisa tu bandeja de entrada o spam. Si necesitas ayuda, contacta al Centro de ayuda de <a href='https://ayuda.bancoguayaquil.com/hc/es' target='_blank'><strong>Banco Guayaquil</strong></a> o de <a href='https://www.peigo.com.ec/ayuda' target='_blank'><strong>peiGo</strong></a>, o escríbenos por WhatsApp al <a href='https://wa.me/+593988446600' target='_blank'><strong>098 844 6600.</strong></a>" },
            { field: "terms", label: "He leído y acepto los ", termsText: "Términos y condiciones", termsLink: "/GanaConMastercardDebit/terminos-y-condiciones", addClassName: "terms" },
            { field: "terms2", label: "He leído la Política de Protección de Datos y consiento el tratamiento de mis datos personales. ", termsText: "Configurar consentimiento", actionLink: "ConfigurarConsentimiento()" , action: true, termsLink: "", addClassName: "terms" },
            { field: "img", termsLink: "/assets/images/Dots.png"},
            { field: "terms3", label: "Autorizo recibir información sobre ofertas, productos y servicios del Banco.", termsText: "", termsLink: "" },
            { field: "terms4", label: "Autorizo la personalización de mi experiencia en relación con ofertas, productos y servicios del Banco.", termsText: "", termsLink: "" }
          ]}
          buttonText="Ingresar"
          background="#fff"
          autologin={autologin}
          hash={hash}
        />
        {/* </Container> */}

      </div>
    </>

  )
}
export default Login